import {
  smbCoreMonitoringPlanData,
  smbProMonitoringPlanData,
  smbProPlusMonitoringPlanData
} from '@ecomm/maps/data/businessPlanData'
import { MonitoringCard } from './MonitoringCard'
import { MonitoringCards } from './index'

export function BusinessMonitoringCards({
  showCartCTAs = false
}: { readonly showCartCTAs?: boolean }) {
  return (
    <MonitoringCards>
      <MonitoringCard
        plan={smbCoreMonitoringPlanData}
        showCartCTA={showCartCTAs}
      />
      <MonitoringCard
        plan={smbProMonitoringPlanData}
        showCartCTA={showCartCTAs}
      />
      <MonitoringCard
        plan={smbProPlusMonitoringPlanData}
        showCartCTA={showCartCTAs}
      />
    </MonitoringCards>
  )
}
